<template>
  <div class="table-detail">
    <el-card shadow="never" class="table-card">
      <template #header>
        <div class="detail-header">
          <div class="header-left">
            <el-button text type="primary" @click="goBack">
              <el-icon><ArrowLeft /></el-icon> 返回
            </el-button>
            <h2>桌台 {{ tableStore.tableNo }} 详情</h2>
            <el-button v-if="tableStore.tableSessionId" type="primary" @click="changeTable" style="margin-left:5px">
              换桌
            </el-button>
          </div>
          <div class="header-right">
            <el-button type="primary" @click="printFun" :disabled="tableStore.unpaidTotalPrice === 0">打印小票</el-button>
            <el-button type="success" @click="handleCheckout" :disabled="tableStore.unpaidTotalPrice === 0">结账</el-button>
            <el-button type="danger" @click="handleEndOrder" :disabled="tableStore.unpaidTotalPrice !== 0 || tableStore.customerCnt === 0">结束订单</el-button>
          </div>
        </div>
      </template>

      <!-- 桌台基本信息 -->
      <div class="table-info">
        <el-descriptions :column="4" border>
          <el-descriptions-item label="桌号">{{ tableStore.tableNo }}</el-descriptions-item>
          <el-descriptions-item label="楼层-类型">{{ tableStore.floor }} - {{ tableStore.type }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="tableStore.customerCnt !== 0 ? 'warning' : 'success'">
              {{ tableStore.customerCnt !== 0 ? '用餐中' : '空闲' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="容纳人数">{{ tableStore.capacity }}人</el-descriptions-item>
          <el-descriptions-item label="单号">{{ tableStore.tableSessionId }}</el-descriptions-item>
          <el-descriptions-item label="当前人数">{{ tableStore.customerCnt }}人</el-descriptions-item>
          <el-descriptions-item label="开台时间">
            {{ tableStore.startTime ? tzDayjs.formatTime(tableStore.startTime) : '' }}
          </el-descriptions-item>
          <el-descriptions-item label="用餐时长">
            {{ tableStore.startTime ? tzDayjs.formatDuration(tableStore.startTime) : '' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 左右两栏布局：左侧订单明细，右侧菜单 + 购物车 -->
      <el-row :gutter="16" class="content-row">
        <!-- 左侧：订单明细 -->
        <el-col :span="12" class="left-col">
          <div class="order-section">
            <!-- 未支付区域 -->
            <div class="order-subsection unpaid-section">
              <div class="subsection-header">
                <h4>待支付</h4>
                <span class="subsection-total">合计：¥{{ tableStore.unpaidTotalPrice.toFixed(1) }}</span>
              </div>
              <el-table :data="tableStore.unpaidOrders" stripe style="width: 100%" size="small">
                <el-table-column prop="name" label="菜品名称" min-width="120" />
                <el-table-column prop="quantity" label="数量" width="60" align="center" />
                <el-table-column prop="price" label="单价" width="70" align="right">
                  <template #default="{ row }">¥{{ row.price.toFixed(1) }}</template>
                </el-table-column>
                <el-table-column label="小计" width="80" align="right">
                  <template #default="{ row }">¥{{ (row.price * row.quantity).toFixed(1) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="110" align="center">
                  <template #default="{ row }">
                    <el-tag :type="row.isServed ? 'success' : 'warning'" size="small" :title="tzDayjs.formatTime(row.isServed ? row.servedTime : row.orderTime)">
                      {{ row.isServed ? '已上菜' : '待上菜' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60" align="center">
                  <template #default="{ row }">
                    <el-button type="primary" link @click="cancelDish(row)">退订</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 已支付区域 -->
            <div class="order-subsection paid-section">
              <div class="subsection-header">
                <h4>已支付</h4>
                <span class="subsection-total">合计：¥{{ tableStore.paidTotalPrice.toFixed(1) }}</span>
              </div>
              <el-table :data="tableStore.paidOrders" stripe style="width: 100%" size="small">
                <el-table-column prop="name" label="菜品名称" min-width="120" />
                <el-table-column prop="quantity" label="数量" width="60" align="center" />
                <el-table-column prop="price" label="单价" width="70" align="right">
                  <template #default="{ row }">¥{{ row.price.toFixed(1) }}</template>
                </el-table-column>
                <el-table-column label="小计" width="80" align="right">
                  <template #default="{ row }">¥{{ (row.price * row.quantity).toFixed(1) }}</template>
                </el-table-column>
                <el-table-column label="状态" width="110" align="center">
                   <template #default="{ row }">
                    <el-tag type="success" size="small" :title="tzDayjs.formatTime(row.paidTime)">已支付</el-tag>
                   </template>
                </el-table-column>
                <el-table-column label="操作" width="60" align="center">
                  <template #default="{ row }">
                    <el-button type="primary" link @click="cancelDish(row)">退订</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>

        <!-- 右侧：菜单 + 购物车 -->
        <el-col :span="12" class="right-col">
          <div class="order-section">
            <!-- 菜单区域 -->
            <div class="menu-section">
              <div class="section-header">
                <h4>菜单</h4>
                <div class="search-box">
                  <el-input
                    v-model="searchKeyword"
                    placeholder="搜索菜品"
                    clearable
                  >
                    <template #prefix>
                      <el-icon><Search /></el-icon>
                    </template>
                  </el-input>
                </div>
              </div>
              <div class="menu-grid">
                <el-row :gutter="4">
                  <el-col
                    v-for="dish in filteredDishes"
                    :key="dish.id"
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                  >
                    <el-card class="menu-card" shadow="hover" :body-style="{ padding: '8px' }">
                      <div class="menu-card-content">
                        <div class="menu-dish-name">{{ dish.name }}</div>
                        <div class="menu-dish-price">¥{{ dish.currentPrice.toFixed(1) }}</div>
                        <el-button
                          type="primary"
                          size="small"
                          @click="cartStore.updateQuantity(dish, 1)"
                        >
                          加菜
                        </el-button>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>

            <!-- 购物车区域 -->
            <div class="cart-section">
              <div class="section-header">
                <h4>购物车</h4>
                <el-button type="success" @click="submitCart" :disabled="cartStore.items.length === 0">
                  提交订单
                </el-button>
              </div>
              <el-empty v-if="cartStore.items.length === 0" description="购物车空空如也" :image-size="60" />
              <div v-else class="cart-grid">
                <el-row :gutter="4">
                  <el-col
                    v-for="item in cartStore.items"
                    :key="item.dishId"
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="8"
                  >
                    <el-card class="cart-item-card" shadow="hover" :body-style="{ padding: '8px' }">
                      <div class="cart-item-content">
                        <span class="cart-item-name" :title="item.name">{{ item.name }}</span>
                        <div class="quantity-controls">
                          <el-button size="small" @click="cartStore.updateQuantity(item, -1)" class="quantity-btn">
                            <el-icon><Minus /></el-icon>
                          </el-button>
                          <span class="quantity">{{ item.quantity }}</span>
                          <el-button size="small" @click="cartStore.updateQuantity(item, 1)" class="quantity-btn">
                            <el-icon><Plus /></el-icon>
                          </el-button>
                        </div>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    
    <DropdownDialog 
      v-model="changeTableDialog"
      :optionList="allTableStore.tables.filter(t => !t.startTime).map(t => ({label:t.tableNo, value:t.tableNo}))"
      @confirm="changeTableConfirmed"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowLeft } from '@element-plus/icons-vue'
import { useTableStore } from '@/stores/common/tableStore'
import { useAllTableStore } from '@/stores/admin/allTableStore'
import { useMenuStore } from '@/stores/common/menuStore'
import { useCartStore } from '@/stores/common/cartStore'
import { usePrintStore } from '@/stores/admin/printStore'
import tzDayjs from '@/utils/dayjs'
import { leftAlign, rightAlign, splitByVisualWidth} from '@/utils/printUtils'
import DropdownDialog from '@/components/DropdownDialog.vue'


const router = useRouter()
const tableStore = useTableStore()
const menuStore = useMenuStore()
const cartStore = useCartStore()
const printStore = usePrintStore()
const allTableStore = useAllTableStore()
const changeTableDialog = ref(false)

const searchKeyword = ref('')

// 根据搜索词过滤菜品
const filteredDishes = computed(() => {
  if (!searchKeyword.value) return menuStore.dishList
  return menuStore.dishList.filter(dish => dish.name.includes(searchKeyword.value))
})

// 返回上一页
const goBack = () => {
  router.back()
}

// 结账
const handleCheckout = async () => {
  ElMessageBox.confirm(`确认结账？(待结账金额：¥${tableStore.unpaidTotalPrice.toFixed(1)})`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'info'
  }).then( async () => {
    await tableStore.checkout()
    ElMessage.success('结账成功')
  }).catch(() => {})
}

// 结束订单
const handleEndOrder = async () => {
  ElMessageBox.confirm('确认结束订单？此操作将清空该桌所有菜品。', '警告', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then( async () => {
    await tableStore.endOrder()
    ElMessage.success('订单已结束')
  }).catch(() => {})
}

// 修改菜品数量（弹窗输入新数量）
const cancelDish = async (dish) => {
  const { value: newQuantity } = await ElMessageBox.prompt(`请输入要退订的数量（当前为${dish.quantity}份）`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    inputValue: dish.quantity,
    inputPattern: /^[1-9]\d*$/,
    inputErrorMessage: '请正确输入要退订的数量',
    inputValidator: (val) => {
        const num = Number(val)
        if (num > dish.quantity) {
          return '退订数量不能超过当前份数'
        }
        return true // 验证通过
      }
  }).catch(() => ({ value: null }))
  if (newQuantity === null) return
  
  await tableStore.cancelDish({
    orderId: dish.orderId,
    dishId: dish.dishId,
    quantity: Number(dish.quantity) - Number(newQuantity),
    dishName: dish.name,
    isServed: dish.isServed,
    cancelQuantity: newQuantity
  })
  ElMessage.success('退订成功')
  await tableStore.getOrderList()
}

// 换桌
const changeTable = () => {
  changeTableDialog.value = true
}

const changeTableConfirmed = async (tableNo) => {
  await tableStore.tableChange(tableNo)
  ElMessage.success('桌台更新成功')
  router.back()
}

// 提交购物车
const submitCart = async () => {
  if (cartStore.items.length === 0) return

  // 还没输入人数的情况
  if(tableStore.customerCnt === 0 ){
    const { value: customerCnt } = await ElMessageBox.prompt('进餐人数', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputValue: 1,
      inputPattern: /^[1-9]\d*$/,
      inputErrorMessage: '数量必须为正整数'
    }).catch(() => ({ value: null }))
    if (customerCnt === null) return
    tableStore.setCustomerCnt(customerCnt)
    tableStore.setStartTime()
  }

  const p = {
    tableNo : tableStore.tableNo,
    customerCnt : tableStore.customerCnt,
    startTime : tableStore.startTime
  }
  const res = await cartStore.checkout(p)
  tableStore.updateState(res)
  ElMessage.success('订单提交成功')
  await tableStore.getOrderList()
}

const printFun = () => {
  let result = ''
  result += '<C><L1>' + sessionStorage.getItem('tenantName') + '</L1></C><BR>'
  result += '<C><L1>结账单</L1></C><BR>'
  result += '-'.repeat(32) + '<BR>'
  result +=  leftAlign('桌号：'+ tableStore.tableNo, 22) + rightAlign('桌号：' + tableStore.customerCnt + '人', 10)  + '<BR>'
  result +=  '开台时间：' + tzDayjs.formatDateTime(tableStore.startTime) + '<BR>'
  result +=  '结账时间：' + tzDayjs.formatDateTime(new Date()) + '<BR>'
  result +=   '单号：' + tableStore.tableSessionId + '<BR>'
  result +=   '收银员：' + sessionStorage.getItem('userName') + '<BR>'
  result += '-'.repeat(32) + '<BR>'
  result +=  leftAlign('品项', 16) + rightAlign('数量', 4) + rightAlign('单价', 6) + rightAlign('小计', 6) + '<BR>'
  result += tableStore.unpaidOrders.map(dish => {
    const nameParts = splitByVisualWidth(dish.name, 16); // 第一行最多16视觉宽度
    const firstLine = leftAlign(nameParts[0], 16) 
                    + rightAlign(dish.quantity + '份', 4) 
                    + rightAlign(dish.price.toFixed(1), 6) 
                    + rightAlign((dish.price * dish.quantity).toFixed(1), 6);
    // 后续行仅显示剩余菜名，右侧留空（宽度为4+6+6=16个字符位置）
    const otherLines = nameParts.slice(1).map(part => leftAlign(part, 16) + ' '.repeat(16)).join('<BR>');
    return otherLines ? `${firstLine}<BR>${otherLines}` : firstLine;
  }).join('<BR>')
  result += '-'.repeat(32) + '<BR>'
  // 放大一倍所哟总长度为16
  result += '<L1><B>' + leftAlign('合计', 8) + rightAlign(tableStore.unpaidTotalPrice.toFixed(1), 8) + '</B></L1><BR>'
  result += '<BR><C>感谢您的光临！欢迎再次惠顾！</C>'
  printStore.print(result) 
}

// 加载数据
onMounted(async () => {
  if(!tableStore.tableNo){
    ElMessage.error('桌台信息不存在')
    router.back()
  }
  await tableStore.getOrderList()
  await menuStore.getDishList()
})

onUnmounted(async () => {
  cartStore.clearCart()
})
</script>

<style scoped>
.table-detail {
  width: 100%;
  height: 100%;
  overflow: hidden; /* 防止整体滚动 */
}
.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 2px;
}

.header-left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.header-right {
  display: flex;
  gap: 12px;
}

.table-info {
  margin-bottom: 24px;
}

/* 内容行占满剩余高度 */
.content-row {
  height: calc(100vh - 220px); /* 根据实际头部总高度调整，包含卡片头部、描述区域、间距等 */
  margin-top: 16px;
  overflow: hidden;
}

.left-col,
.right-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.order-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  overflow: hidden;
}

/* 订单子区域公共样式 */
.order-subsection {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.subsection-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.subsection-total {
  font-size: 14px;
  font-weight: 500;
  color: #ff6b6b;
}

/* 未支付区域高度 400px */
.unpaid-section {
  height: 250px;
  flex-shrink: 0;
}
.unpaid-section .el-table {
  flex: 1;
  overflow-y: auto;
}

/* 已支付区域高度 200px */
.paid-section {
  height: 250px;
  flex-shrink: 0;
}
.paid-section .el-table {
  flex: 1;
  overflow-y: auto;
}

/* 菜单区域高度 400px */
.menu-section {
  height: 250px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 购物车区域高度 200px */
.cart-section {
  height: 250px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.section-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.search-box {
  width: 200px;
}

.menu-grid,
.cart-grid {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-card {
  margin-bottom: 8px;
  transition: transform 0.2s;
}

.menu-card:hover {
  transform: translateY(-2px);
}

.menu-card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.menu-dish-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.menu-dish-price {
  font-size: 14px;
  font-weight: 600;
  color: #ff6b6b;
  white-space: nowrap;
}

/* 购物车卡片样式 */
.cart-item-card {
  margin-bottom: 8px;
}

.cart-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cart-item-name {
  flex: 2;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-item-price {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #ff6b6b;
  text-align: right;
}

.quantity-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.quantity-btn {
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: white;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity {
  min-width: 24px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

/* 可保留的分类按钮样式，如不需要可删除 */
.menu-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
</style>